import { Repository } from './Repository';

export default class AuthRepository extends Repository {
    constructor() {
        super();

        this.authRequestPrefix = '/api/v1/authentications';
        this.userRequestPrefix = '/api/v1/user';
    }

    login = (url, param) => {
        return this.getRequestPromise('post', this.authRequestPrefix + `/${url}`, param);
    };

    checkLogin = (url) => {
        return this.getRequestPromise('get', this.authRequestPrefix + `/${url}`);
    };

    logout = (url) => {
        return this.getRequestPromise('post', this.authRequestPrefix + `/${url}`);
    };

    sendFindPasswordEmail = (url) => {
        return this.getRequestPromise('post', this.userRequestPrefix + `/${url}`);
    };

    resetPassword = (url, param) => {
        return this.getRequestPromise('put', this.userRequestPrefix + `/${url}`, param);
    };
}
